import { axios } from '@/utils/request'
import relUtil from "@/utils/relUtil";
import storage   from "../../utils/storage";
const channelUrl = relUtil.channelUrl;

export function changePassWord (obj) {
  return axios({
    url: channelUrl+'/channelUsers/'+storage.get('user').userId+'/password/',
    method: 'PATCH',
    data:obj
  })
}



// WEBPACK FOOTER //
// ./src/service/changePas/changePasService.js